
import React, { useState, useEffect } from 'react';

import { HiOutlineSearch } from "react-icons/hi";

import { logOut } from "../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";

import { getProfile } from "../store/actions/profileActions";
import {getRisks} from "../store/actions/riskActions";
import { getControls_Report, getControls_Search, editControl } from "../store/actions/riskActions";
import ControlOverlay from "../components/Control/ControlOverlay";
import RiskDetailsForm from "../components/Risk/RiskOverlay";
import Popup from 'reactjs-popup';
import { useHistory, useLocation } from 'react-router-dom'

const SearchBar = ({profile, getRisksFN, editControlFN, getControlsReportFN, getControlsSearchFN, risks, controls} ) => {

  const history = useHistory()
  const { pathname } = useLocation()

  const [flattenedControls, setFlattenedControls] = useState([]);
  const [selectedControl, setSelectedControl] = useState(null);
  const [selectedRiskID, setSelectedRiskID] = useState(null);
  const [open, setOpen] = useState(false)


   const goToRisk = id => {
    // derive domain segment if needed
    const domain = pathname.split('/')[1] || ''
    // push new URL with risk ID param
    history.push(`/risk/${id}`)
  }

   useEffect(() => {
    if (profile?.department_id) {
        //console.log("Risks Getting", profile.department_id)
        getRisksFN(1, 100, profile.department_id, "None")
    }
    }, [getRisksFN, profile.department_id]);

    useEffect(() => {
    if (profile) {
        //console.log("Controls Getting", profile.department_id)
        //getControlsReportFN( profile.department_id)
        getControlsSearchFN(profile.department_id)
    }
    }, [getControlsSearchFN, profile.department_id]);
    
    useEffect(() => {
          if (controls && controls?.length > 0) {
              //console.log("Controls before flat:" , controls);
              const allControls = controls
                  .filter((control) =>
                      control.controls.some(
                          (c) =>
                              c.controlDetails !== null ||
                              c.controlType !== null ||
                              c.controlDefinition !== null
                      )
                      
                  )
                  .flatMap((control) =>
                      control.controls.map((c) => ({
                          ...c,
                          riskId: control.riskId,
                          title: control.title,
                          owner: c.owner,
                      }))
                  );
              setFlattenedControls(allControls);
          } else {
              setFlattenedControls([]);
          }
      }, [controls]);


    const [search, setSearch] = useState("");


  const closeCreation = async (data, control_id, risk_id) => {
    console.log("Data:", data, "ID", control_id)

    setSelectedControl(null)
    await updateServerData(data, control_id, risk_id);
    getControlsSearchFN(profile.department_id)

  }

  const updateServerData = async (data, control_id, risk_id) => {


    const updatedData = { ...data };

    // Add one day to StartDate and EndDate if they exist
    if (updatedData.StartDate) {
      const startDate = new Date(updatedData.StartDate);
      startDate.setDate(startDate.getDate() + 1);
      updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }

    if (updatedData.EndDate) {
      const endDate = new Date(updatedData.EndDate);
      endDate.setDate(endDate.getDate() + 1);
      updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    }

    //console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

    await editControlFN(risk_id, control_id, updatedData);


  }
  const filteredA = risks.filter((risk) =>
    risk.Title.toLowerCase().includes(search.toLowerCase())
  );
  //controls = [controls]
  //console.log("Controls",flattenedControls)
  const filteredB = flattenedControls.filter((control) =>
    control.controlDetails.toLowerCase().includes(search.toLowerCase())
  );

//   const filteredClasses = Risks2.filter(Risk =>
//   Risk.title.toLowerCase().includes(search.toLowerCase())
//     );

  return (
    <div className="relative w-80"> {/* keeps dropdown aligned under search bar */}
    <HiOutlineSearch
        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500"
        size={20}
      />
      <input
        type="text"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
       className="w-full pl-8 pr-2 py-1 border rounded text-black bg-white focus:outline-none"
      />

      {open && search.length > 0 && (
        <div className="absolute top-full left-0 w-full max-h-80 overflow-y-auto bg-white border border-gray-200 rounded-lg shadow-md z-10 mt-1">
          {filteredA.length > 0 && (
            <div>
              <p className="pl-4 py-1 font-semibold text-blue-800">Risks</p>
              {filteredA.map((risk, i) => (
                <div
                  key={risk.ID}
                  onClick={() => {
                    setSelectedRiskID(risk.ID);
                    goToRisk(risk.ID);
                    console.log(risk);
                  }}
                  className={`cursor-pointer hover:bg-gray-200 px-4 py-2 ${i < filteredA.length - 1 ? "border-b border-gray-200" : ""
                    }`}
                >
                  <p
                    className="text-base font-medium"
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {risk.Title}
                  </p>
                  <div className="flex space-x-1 text-sm text-gray-500">
                    <span>{risk.OwnerFirstName}</span>
                    <span>{risk.OwnerLastName}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {filteredB.length > 0 && (
            <div className="mt-2">
              <p className="pl-4 py-1 font-semibold text-blue-800">Controls</p>
              {filteredB.map((control, i) => (
                <div
                  key={control.controlID}
                  onClick={() => {
                    setSelectedControl(control);
                    console.log(control);
                  }}
                  className={`cursor-pointer hover:bg-gray-200 px-4 py-2 ${i < filteredB.length - 1 ? "border-b border-gray-200" : ""
                    }`}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  {control.controlDetails}
                </div>
              ))}
            </div>
          )}

          {filteredA.length === 0 && filteredB.length === 0 && (
            <p className="text-gray-400 italic px-4 py-2">No matches</p>
          )}
        </div>
      )}

      

      {selectedControl && (
       <Popup
        open={true}
        onClose={() => setSelectedControl(null)} 
        contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '900px', marginTop: '14vh' }}>
        <ControlOverlay key={selectedControl.controlID || 'new-control'} closeControl={closeCreation} control_id={selectedControl.controlID} risk_id={selectedControl.riskId} />
        </Popup>
      )}

       

    </div>
  );
};


const mapStateToProps = (state) => {
    //console.log("Entire Redux state:", state);
    //console.log("Risks", state.risk.risks);
    return {

        
        profile: state.profile.profile,
        risks: state.risk.risks,
        controls: state.risk.all_risk_controls,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        logOutFN: () => dispatch(logOut()),
        getProfileFN: () => dispatch(getProfile()),
        getRisksFN: (currentPage, pageSize, department_id, sortBy) => dispatch(getRisks(currentPage, pageSize, department_id, sortBy)),
        getControlsReportFN: (departmentId) => dispatch(getControls_Report(departmentId)),
        getControlsSearchFN: (departmentId) => dispatch(getControls_Search(departmentId)),
        editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(SearchBar);